export const firebaseConfig = {
  apiKey: "AIzaSyBLtifJIiW84wAaIsS5n-65JCqewxxSg-I",
  authDomain: "superstudyparty.firebaseapp.com",
  projectId: "superstudyparty",
  storageBucket: "superstudyparty.appspot.com",
  messagingSenderId: "445989614402",
  appId: "1:445989614402:web:afc3b6f57e770febf68edb",
};
